//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <div style="font-family:'Roboto Thin'; font-size:16px; padding-bottom:3px; padding-right: 5px; margin-bottom:15px; border-bottom: solid 1px #ddd; float:left;">Редактирование свойств доски</div>
    <div v-if="editingTaskBoard != null">
      <div style="width:100%; font-family:'Roboto Thin'; font-size:16px; padding-bottom:5px; float:left;">
        Доска:
        <Input v-model="editingTaskBoard.name" size="large" style="width:585px;"/>
      </div>
      <div style="width:100%; font-family:'Roboto Thin'; font-size:16px; padding-bottom:5px; float:left;">
        Участники:
        <Select v-model="editingTaskBoard.members" multiple filterable size="large"
         placeholder="Выберите участников" style="width:550px;">
          <Option v-for="(user, userKey) in commonData.users" :value="user.id" :key="userKey" v-once>{{user.Name}}</Option>
        </Select>
      </div>

      <div style="padding: 30px 0px 0px 0px; float:left">
        <Button type="warning" style="border-radius:3px; margin-bottom:10px;" @click="saveOnClick">Сохранить</Button>
        <Button type="ghost" style="border-radius:3px; margin-bottom:10px;" @click="cancelOnClick">Отменить</Button>
      </div>
    </div>

    <div v-else style="width:100%; padding-top: 20px; float:left">
      <router-link to="/tasks">Вернуться к списку задач</router-link>
    </div>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import serverErrorHandling from '@/technical/serverErrorHandling'

export default {
  data () {
    return {
      editingTaskBoard: null
    }
  },
  watch: {
    // сработает в тех случаях когда панель уже создавалась и открылась, а commonData.taskBoardForChangeSettings вовне заново изменен
    // в остальных случаях работаем через created
    'commonData.taskBoardForChangeSettings': function (newVal, oldVal) {
      if (this.commonData.taskBoardForChangeSettings != null) {
        this.editingTaskBoard = Object.assign({}, this.commonData.taskBoardForChangeSettings.val)
        if (this.editingTaskBoard.members == null) {
          this.editingTaskBoard.members = []
        }
        let membersIDs = []
        this.editingTaskBoard.members.forEach(function (item, i) {
          membersIDs.push(item.id)
        })
        this.editingTaskBoard.members = membersIDs
      } else {
        this.editingTaskBoard = null
        this.membersIDs = null
      }
    }
  },
  created: function () {
    // это случай когда панель открывается первый раз (а значит создается) а commonData.taskBoardForChangeSettings уже установлен и watch выше уже не сработает
    if (this.commonData.taskBoardForChangeSettings != null) {
      this.editingTaskBoard = Object.assign({}, this.commonData.taskBoardForChangeSettings.val)
      if (this.editingTaskBoard.members == null) {
        this.editingTaskBoard.members = []
      }
      let membersIDs = []
      this.editingTaskBoard.members.forEach(function (item, i) {
        membersIDs.push(item.id)
      })
      this.editingTaskBoard.members = membersIDs
    } else {
      this.editingTaskBoard = null
      this.membersIDs = null
    }
  },
  computed: {
    ...mapGetters([
      'commonData'
    ])
  },
  methods: {
    ...mapMutations([
      'commonDataTaskBoardForChangeSettingsSet',
      'commonDataTaskBoardForChangeSettingsSetVal',
      'commonDataTaskBoardsEditVal'
    ]),
    saveOnClick () {
      let thisRef = this
      this.commonDataTaskBoardForChangeSettingsSetVal(this.editingTaskBoard)
      this.commonData.taskBoardForChangeSettings.save()
      .then(function (response) {
        thisRef.commonData.taskBoards[response.data.id].query({id: response.data.id, populate: '[members]'}) // считываем еще раз чтобы включить members в объект
        .then(function (response) {
          thisRef.commonDataTaskBoardsEditVal(response.data[0])
          thisRef.commonDataTaskBoardForChangeSettingsSet(null)
          thisRef.$router.push('/tasks')
        })
      })
      .catch((error) => serverErrorHandling(error, thisRef))
    },
    cancelOnClick () {
      this.commonDataTaskBoardForChangeSettingsSet(null)
      this.$router.push('/tasks')
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 0px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// TaskBoardSettings.vue?57ae586c